import { processingSelectData } from '@/utils/index';
// 计费方式
export const CONTRACT_CHARGE_TYPE = [
  {
    label: '计价器计费',
    value: 'TAXIMETER_PRICE',
  },
  {
    label: '合同计费',
    value: 'CONTRACT_PRICE',
  },
  {
    label: '按趟次计费',
    value: 'FREQUENCY_PRICE',
  },
];
// 站点范围
export const SITE_RULE = [
  {
    label: '货主所属租户',
    value: 'CUSTOMER_TENANT',
  },
  {
    label: '货主编码',
    value: 'CUSTOMER_CODE',
  },
  {
    label: '企业社会信用代码',
    value: 'CUSTOMER_CREDIT_CODE',
  },
];
// 货品范围
export const GOODS_RULE = [
  {
    label: '货主所属租户',
    value: 'CUSTOMER_TENANT',
  },
  {
    label: '货主编码',
    value: 'CUSTOMER_CODE',
  },
  {
    label: '企业社会信用代码',
    value: 'CUSTOMER_CREDIT_CODE',
  },
];

// 时间单位
export const TIME_UNIT = {
  DAYS: '天',
  HOURS: '时',
};

// 接单节点(接单日期类型)
export const RECEIVING_TIME_TYPE = {
  createTime: '下单日期',
  startTime: '取货日期',
  reachTime: '送货日期',
};

// 接单节点(接单阶段类型)
export const RECEIVING_STSGE_TYPE = {
  BEFORE: '之前',
  AFTER: '之后',
};

export const OVERTIME_TYPE = {
  CUSTOME_TIME: 'CUSTOME_TIME',
  BASIS_TABLE_FIELD: 'BASIS_TABLE_FIELD',
};
// 接单节点(节点超时类型)
export const OVERTIME_TYPE_MAP = {
  CUSTOME_TIME: '自定义时间',
  BASIS_TABLE_FIELD: '根据表单字段',
};

export const timeReg = /^[1-9]\d?$|^[1-2]\d{2}$|^3[0-5]\d$|^36[0-5]$/;
export const reg = /^\d{0,6}(\.\d{0,2})?$/;

export const createOederNav = [
  {
    index: 1,
    label: '站点选择范围',
    ref: 'site',
  },
  {
    index: 2,
    label: '货品选择范围',
    ref: 'goods',
  },
  {
    index: 3,
    label: '下单时间校验',
    ref: 'order',
  },
  {
    index: 4,
    label: '预计费规则',
    ref: 'prepayment',
  },
  // {
  //   index: 5,
  //   label: '子母单',
  //   ref: 'multiPieces',
  // },
  {
    index: 5,
    label: '订单业务标签',
    ref: 'orderBusinessLabel',
  },
  {
    index: 6,
    label: '下单任务预警',
    ref: 'timeoutNotification',
  },
  {
    index: 7,
    label: '自定义字段',
    ref: 'custom',
  },
];

export const detailField = {
  GOODS_RULE: [
    {
      label: '货品重量范围',
      prop: 'SKU_WEIGHT_RANGE',
      formatter: (row) => (row.SKU_WEIGHT_RANGE.lower ? `${row.SKU_WEIGHT_RANGE.lower}至${row.SKU_WEIGHT_RANGE.upper}` : '--'),
      unit: 'kg',
    },
    {
      label: '货品体积范围',
      prop: 'SKU_VOLUME_RANGE',
      formatter: (row) => (row.SKU_WEIGHT_RANGE.lower ? `${row.SKU_VOLUME_RANGE.lower}至${row.SKU_VOLUME_RANGE.upper}` : '--'),
      unit: 'm³',
    },
    {
      label: '货品件数范围',
      prop: 'SKU_SUM_RANGE',
      formatter: (row) => (row.SKU_SUM_RANGE.lower ? `${row.SKU_SUM_RANGE.lower}至${row.SKU_SUM_RANGE.upper}` : '--'),
      unit: '件',
    },
    {
      label: '货品重泡比',
      prop: 'SKU_WEIGHT_VOLUME_RATIO',
      formatter: (row) => row.SKU_WEIGHT_VOLUME_RATIO.num || '--',
    },
    {
      label: '重量体积二选一',
      prop: 'SKU_IGNORE_WEIGHT_VOLUME',
      formatter: (row) => (row.SKU_IGNORE_WEIGHT_VOLUME.flag ? '开启' : '未开启'),
    },
  ],
  TIME_RULE: [
    {
      label: '取货时间',
      prop: 'CREATE_START_TIME',
      formatter: (row) => (row.CREATE_START_TIME.num ? `T+${row.CREATE_START_TIME.num} ${TIME_UNIT[row.CREATE_START_TIME.unit]}` : '--'),
    },
    {
      label: '取货补录时间',
      prop: 'MAKEUP_START_TIME',
      formatter: (row) => (row.MAKEUP_START_TIME.num ? `T-${row.MAKEUP_START_TIME.num} ${TIME_UNIT[row.MAKEUP_START_TIME.unit]}` : '--'),
    },
    {
      label: '送达时间',
      prop: 'CREATE_REACH_TIME',
      formatter: (row) => (row.CREATE_REACH_TIME.num ? `T+${row.CREATE_REACH_TIME.num} ${TIME_UNIT[row.CREATE_REACH_TIME.unit]}` : '--'),
    },
    {
      label: '送达补录时间',
      prop: 'MAKEUP_REACH_TIME',
      formatter: (row) => (row.MAKEUP_REACH_TIME.num ? `T-${row.MAKEUP_REACH_TIME.num} ${TIME_UNIT[row.MAKEUP_REACH_TIME.unit]}` : '--'),
    },
  ],
  BILL_QUOTA: [
    {
      label: '计费限额',
      prop: 'PRICING_QUOTA',
      formatter: (row) => (row.PRICING_QUOTA.lower ? `${row.PRICING_QUOTA.lower}至${row.PRICING_QUOTA.upper}` : '--'),
      unit: '元',
    },
  ],
};

// 接单节点(条件类型)
export const CONDITION_TYPE = {
  CUSTOMER_CODE: 'CUSTOMER_CODE',
  TENANT_ID: 'TENANT_ID',
  ROOT_CUSTOMER_NAME: 'ROOT_CUSTOMER_NAME',
  ASSIGNED: 'ASSIGNED',
  TRANSPORT_COST: 'TRANSPORT_COST',
  ORDER_CHANNEL: 'ORDER_CHANNEL',
};

// 接单节点(条件类型)
export const CONDITION_TYPE_MAP = {
  // [CONDITION_TYPE.CUSTOMER_CODE]: '客户编码',
  // [CONDITION_TYPE.TENANT_ID]: '租户编码',
  [CONDITION_TYPE.ROOT_CUSTOMER_NAME]: '外部客户名称',
  [CONDITION_TYPE.ASSIGNED]: '转派标识',
  [CONDITION_TYPE.TRANSPORT_COST]: '计划应收',
  [CONDITION_TYPE.ORDER_CHANNEL]: '订单来源',
};

// 订单来源
export const ORDER_CHANNEL = {
  SHIPPER: '货主下单',
  CARRIER: '承运商下单',
  IMPORT_ORDER: '导入订单',
  LIUHE_ORDER: '六合订单',
  DAIRY_ORDER: '乳业订单',
  EMAIL_ORDER: '邮件下单',
  TURN_TO_SEND_ORDER: '转派订单',
  UNKNOWN3: '未知 1',
  FRUIT_ORDER: '果盘运单',
  PROPAGATE: '主订单衍生（运单拆分产生)',
  GUOPAN_MINI_APP: '小程序订单',
  FRESH_SCM: '商流订单',
  CUSTOMER_ORDER: '货主订单',
  CUSTOMER_IMPORT: '货主导入',
  CUSTOMER_OPEN_API: '货主OpenApi下单',
  RTS_OPEN_API: '乳业订单OpenApi下单',
  CUSTOMER_MINI_APP: '小程序货主订单',
};
// 填写类型
export const WRITE_TYPE = [
  {
    label: '为空',
    value: true,
  },
  {
    label: '不为空',
    value: false,
  },
];
// 条件选择表单验证
export const CONDITION_RULES = {
  TYPE: [
    { required: true, message: '请选择', trigger: 'change' },
  ],
  CONDITION: [
    { required: true, message: '请选择', trigger: 'change' },
  ],
  CONDITION_VALUE: [
    { required: true, message: '请选择', trigger: ['blur', 'change'] },
  ],
};

function validateFreNumber(rule, value, callback) {
  if (!value.startTime || !value.endTime || value.intervalDays === '' || value.intervalDays === undefined) {
    callback(new Error('开始时间、间隔天数、结束时间必都必填'));
  }
  callback();
}

// 条件选择表单验证
export const TACTICS_RULES = {
  CONDITION: [
    { required: true, message: '请选择', trigger: 'change' },
  ],
  FREQUENCY_NUMBER: [
    { required: true, validator: validateFreNumber, trigger: 'change' },
  ],
};

// 条件种类
export const CONDITION_KIND = {
  EQ: '等于',
  NE: '不等于',
  // INCLUDE: '包含',
  // UNINCLUDE: '不包含',
};

export const StarObjectList = [
  {
    value: 'CAR',
    label: '车辆',
  },
  {
    value: 'DRIVER',
    label: '司机',
  },
];

// 子母单状态
export const markStatus = {
  ENABLE: 'ENABLE',
  RECONCILED: 'RECONCILED',
  DELETED: 'DELETED',
};
// 子母单状态
export const markStatusMap = {
  ENABLE: '生效中',
  RECONCILED: '已对账',
  DELETED: '删除',
};

// 子母单列表
export const multiPiecesColumn = [
  {
    label: '标识',
    prop: 'code',
    width: 180,
  },
  {
    label: '辅助说明',
    prop: 'name',
    minWidth: 180,
  },
  {
    label: '状态',
    prop: 'markStatus',
    minWidth: 180,
  },
  {
    label: '操作',
    prop: 'action',
    minWidth: 180,
    fixed: 'right',
  },
];

// 预警频率
const frequency = {
  DAY: '每日',
  WEEK: '每周',
};

// 固定星期
const weekOptions = [
  {
    label: '星期一',
    value: 'MONDAY',
  },
  {
    label: '星期二',
    value: 'TUESDAY',
  },
  {
    label: '星期三',
    value: 'WEDNESDAY',
  },
  {
    label: '星期四',
    value: 'THURSDAY',
  },
  {
    label: '星期五',
    value: 'FRIDAY',
  },
  {
    label: '星期六',
    value: 'SATURDAY',
  },
  {
    label: '星期天',
    value: 'SUNDAY',
  },
];

const earlyWarning = {
  FEI_SHU: '飞书消息',
};

// 创建订单接单超时消息通知表单配置
export const createOrderTimeoutNotification = [
  {
    label: '下单频率',
    prop: 'frequency',
    ruleProp: 'CREATE_NOTIFY.frequency',
    formType: 'select',
    subFormType: 'el-option',
    options: processingSelectData(frequency),
    rules: [{ required: true, message: '请选择下单频率', trigger: 'change' }],
    colSpan: 17,
  },
  {
    isShow: (form) => form.frequency === 'WEEK',
    label: '固定星期',
    prop: 'weeks',
    ruleProp: 'CREATE_NOTIFY.weeks',
    formType: 'select',
    subFormType: 'el-option',
    options: weekOptions,
    formAttributes: {
      multiple: true,
    },
    rules: [{ required: true, message: '请选择固定星期', trigger: 'change' }],
    colSpan: 17,
  },
  {
    label: '截单时间',
    prop: 'deadline',
    ruleProp: 'CREATE_NOTIFY.deadline',
    formType: 'time-picker',
    formAttributes: {
      valueFormat: 'HH:mm:ss',
      placeholder: '请选择截单时间',
    },
    rules: [{ required: true, message: '请选择截单时间', trigger: 'change' }],
    colSpan: 17,
  },
  {
    label: '预警方式',
    prop: 'notifyChannels',
    ruleProp: 'CREATE_NOTIFY.notifyChannels',
    formType: 'checkbox',
    subFormType: 'el-checkbox',
    options: processingSelectData(earlyWarning),
    rules: [{ required: true, message: '请选择预警方式', trigger: 'change' }],
    colSpan: 17,
  },
  {
    label: '指定人群',
    prop: 'appointUserIds',
    ruleProp: 'CREATE_NOTIFY.appointUserIds',
    rules: [{ required: true, message: '请选择指定人群', trigger: 'change' }],
    colSpan: 17,
    slot: 'appointUserIds',
  },
];

const crowdType = {
  PROJECT_LEADER: '项目负责人',
  APPOINT_USER: '指定人群',
};

// 通知时间类型(预警)
export const NOTIFY_TIME_TYPE = {
  CREATE_TIME: '订单创建时间',
  START_TIME: '要求取货时间',
  REACH_TIME: '期望送达时间',
};
// 接单超时消息通知表单配置
export const receiveOrderTimeoutNotification = [
  {
    label: '预警方式',
    prop: 'notifyChannels',
    ruleProp: 'DEAL_NOTIFY.notifyChannels',
    formType: 'checkbox',
    subFormType: 'el-checkbox',
    options: processingSelectData(earlyWarning),
    rules: [{ required: true, message: '请选择预警方式', trigger: 'change' }],
    colSpan: 17,
  },
  {
    label: '通知人群',
    prop: 'sendObject',
    ruleProp: 'DEAL_NOTIFY.sendObject',
    formType: 'checkbox',
    subFormType: 'el-checkbox',
    options: processingSelectData(crowdType),
    rules: [{ required: true, message: '请选择通知人群', trigger: 'change' }],
    colSpan: 17,
  },
  {
    isShow: (form) => form.sendObject.includes('APPOINT_USER'),
    label: '指定人群',
    prop: 'appointUserIds',
    ruleProp: 'DEAL_NOTIFY.appointUserIds',
    rules: [{ required: true, message: '请选择指定人群', trigger: 'change' }],
    colSpan: 17,
    slot: 'appointUserIds',
  },
];

// 仓储流程配置相关
// 出入库流程类型
export const flowConfigType = {
  sync: 'SYNC_CREATE',
  scheduled: 'SCHEDULED_CREATE',
};
// 仓配一体流程配置-入库
export const STORE_PROCESS_RULE = [
  {
    label: '同步创建运输和仓订单',
    value: flowConfigType.sync,
  },
  {
    label: '先运输订单排线后创建仓订单',
    value: flowConfigType.scheduled,
  },
];

// 仓配一体流程配置-出库
export const DELIVERY_PROCESS_RULE = [
  {
    label: '同步创建运输和仓订单',
    value: flowConfigType.sync,
  },
  {
    label: '先运输订单排线后创建仓订单',
    value: flowConfigType.scheduled,
  },
];
